import { Link } from 'react-router-dom';
import { format } from "date-fns";
import { Tooltip } from '@mui/material';

export const createLanguageColumn = (field, headerName, language, t, minWidth = 170) => {
    if (language === 'languageLNG3' && !window.__UMS_THEME__?.languages?.lng3) return null;

    return {
        field: field,
        headerName: t(headerName) + " " + t(language),
        flex: 1,
        minWidth: minWidth,
        headerClassName: 'tableHeaderClassName',
        cellClassName: 'tableCellClassName',
        renderHeader: (params) => (
            <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
        ),
    };
};

export const createOrderColumn = (t, minWidth = 140) => ({
    field: "orderNo",
    headerName: t("order"),
    flex: 0.3,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    headerAlign: "center",
    align: "center",
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
});





export const createActiveColumn = (t, minWidth = 100) => ({
    field: "active",
    headerName: t("isActive"),
    sortable: false,
    flex: 0.3,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => params.row.isActive
        ? <span className=" text-success me-1 fw-bolder">{t("yes")}</span>
        : <span className=" text-danger me-1 fw-bolder">{t("no")}</span>


});

export const createColumnAction = (
    t,
    editPath,
    removeFn,
    searchValue = "",
    minWidth = 150
) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: "tableHeaderClassName",
    cellClassName: "tableCellClassName",
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <div className="d-flex justify-content-center align-items-center">
            {editPath != null && (
                <Link
                    to={`${editPath}/${params.row.id}`}
                    state={{ search: searchValue }}
                    className="me-3"
                >
                    <i className="bi bi-pencil-fill text-success"></i>
                </Link>
            )}

            {removeFn != null && (
                <div
                    onClick={() => removeFn(params.row.id)}
                    style={{ cursor: "pointer" }}
                >
                    <i className="bi bi-trash-fill text-danger"></i>
                </div>
            )}
        </div>
    ),
});

export const createActionColumn = (t, editPath, removeFn, minWidth = 150) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <div className="d-flex justify-content-center align-items-center">
            {editPath != null && (
                <Link to={`${editPath}/${params.row.id}`} className="me-3">
                    {}
                    <i className="bi bi-pencil-fill text-success"></i>
                </Link>
            )}
            {removeFn != null && (
                <div
                    onClick={() => removeFn(params.row.id)}
                    style={{ cursor: "pointer" }}
                >
                    <i className="bi bi-trash-fill text-danger"></i>
                </div>
            )}
        </div>
    ),
});

export const createSpecialActionColumn = (t, path, minWidth = 150) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <div className="d-flex justify-content-center align-items-center">
            <Link to={`${path}/${params.row.id}`} className="me-3">
                <i className="bi bi-calendar-check text-danger fs-4"></i>
            </Link>

        </div>
    ),
});
export const createQRCodeActionColumn = (t, path, minWidth = 150) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <div className="d-flex justify-content-center align-items-center">
            <Link to={`${path}/${params.row.id}`} className="me-3">
                <i className="bi bi-qr-code text-danger fs-4"></i>
            </Link>

        </div>
    ),

    
});
export const createGroupActionColumn = (t, editPath, removeFn, minWidth = 180) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <div className="d-flex justify-content-center align-items-center">
            <Link

                to={`/Group/StudentList/${params.row.id}`}
                className='text-primary cursor-pointer fw-bolder me-2'
            >

                {t("Student List")}
            </Link>
            {editPath != null && (
                <Link to={`${editPath}/${params.row.id}`} className="me-3">
                    <i className="bi bi-pencil-fill text-primary"></i>
                </Link>
            )}
            {removeFn != null && (
                <div
                    onClick={() => removeFn(params.row.id)}
                    style={{ cursor: "pointer" }}
                >
                    <i className="bi bi-trash-fill text-danger"></i>
                </div>
            )}
        </div>
    ),
});

export const usersCreateActionColumn = (t, editPath, removeFn, minWidth = 250) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <>

            <Link to={`${editPath}/${params.row.id}`}>
                <i className="bi bi-pencil-fill text-success me-2"></i>
            </Link>
            <Link
                to={`/User/ChangePassword/${params.row.id}`}
                className='text-danger cursor-pointer fw-bolder me-2'
            >
                <i className="bi bi-lock-fill  " ></i>
                {"" + t("userChangePassword")}
            </Link>
            <div
                onClick={() => removeFn(params.row.id)}
                style={{ cursor: "pointer" }}
            >
                <i className="bi bi-trash-fill text-danger"></i>
            </div>
        </>
    ),
});

export const usersCreateDataAccessColumn = (t, facultyPath = null, levelPath = null, branchPath = null, minWidth = 250) => ({
    field: "dataAccess",
    headerName: t("dataAccess"),
    sortable: false,
    flex: 1,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <>
            <Link
                to={`/User/FacultyUser/${params.row.id}`}
                className='text-danger cursor-pointer fw-bolder ps-2'
            >
                <i className='bi bi-journal-text'></i>
                {}


                {" " + t("userFacultyDataAccess")}
            </Link>
            <Link to={`/User/BranchObjectUser/${params.row.id}`} className='text-danger cursor-pointer fw-bolder ps-2'>
                <i className='bi bi-building'></i>

                {}
                {t("userBranchObjectDataAccess")}
            </Link>
        </>
    ),
});
export const groupCreateActionColumn = (t, editPath, removeFn, minWidth = 250) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <>
            <Link
                to={`/Group/StudentList/${params.row.id}`}
                className='text-primary cursor-pointer fw-bolder me-2'
            >
                <i className="bi bi-list text-primary " ></i>
                {t("studentList")}
            </Link>

            {editPath != null && (
                <Link to={`${editPath}/${params.row.id}`}>
                    <i className="bi bi-pencil-fill text-primary me-3"></i>
                </Link>
            )}
            {removeFn != null && (
                <div
                    onClick={() => removeFn(params.row.id)}
                    style={{ cursor: "pointer" }}
                >
                    <i className="bi bi-trash-fill text-danger"></i>
                </div>
            )}
        </>
    ),
});



export const createNewGeneralColumn = (
    field,
    headerName,
    t,
    minWidth = 80,
    maxWidth = 300,
    customRenderCell = null,
    flex = 1
  ) => ({
    field,
    headerName: t(headerName),
    minWidth,
    maxWidth,
    flex,
    sortable: true,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => <strong>{params.colDef.headerName}</strong>,
    renderCell: (params) => {
      const rawValue = customRenderCell ? customRenderCell(params.value) : params.value;
      const valueStr = rawValue !== undefined && rawValue !== null ? String(rawValue) : '';
  
      let dynamicWidth = minWidth;
      if (valueStr.length) {
        dynamicWidth = Math.min(Math.max(valueStr.length * 10, minWidth), maxWidth);
      }
      if (isNaN(dynamicWidth)) {
        dynamicWidth = minWidth;
      }
  
      return (
        <Tooltip title={valueStr || ''}>
          <span className="cell-ellipsis" style={{ width: dynamicWidth }}>
            {valueStr}
          </span>
        </Tooltip>
      );
    }
  });

export const createGeneralColumn = (field, headerName, t, minWidth = 150, customRenderCell = null) => ({
    field: field,
    headerName: t(headerName),
    flex: 1,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: customRenderCell
        ? (params) => customRenderCell(params.value)
        : (params) => params.value
});
export const createDateColumn = (field, headerName, t, minWidth = 100) => ({
    field: field,
    headerName: t(headerName),
    flex: 0.5,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    valueFormatter: (params) => {
        if (params != null) {
            const date = new Date(params);
            return format(date, "dd/MM/yyyy");
        } else {
            return "-"
        }

    },
});

export const createTimeColumn = (field, headerName, t, minWidth = 100) => ({
    field: field,
    headerName: t(headerName),
    flex: 1,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    valueFormatter: (params) => {
        const date = new Date(params.value);
        return format(date, "h:mm:ss");
    },
});

export const createBoolColumn = (field, headerName, t, minWidth = 140) => ({
    field: field,
    headerName: t(headerName),
    sortable: false,
    flex: 0.3,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => params.row[field]
        ? <i className="bi bi-check-square-fill text-success"></i>
        : <i className="bi bi-x-square-fill text-danger"></i>,
});

export const createDocumentColumn = (field, headerName, t, mainStore, minWidth = 150, filePath = "filePath") => ({
    field: field,
    headerName: t(headerName),
    flex: 1,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => {
        return (
            <a
                href={mainStore.systemDomain + params.row[filePath]}
                download
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer" }}
                className="d-flex">
                {}
                <i className="bi bi-file-earmark-fill text-info mx-1"></i>
                <div>{params.row[field]}</div>
            </a>
        );
    },
});

